var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3334 23.4667L23.4667 25.3334L16 17.8667L8.53335 25.3334L6.66669 23.4667L14.1334 16L6.66669 8.53335L8.53335 6.66669L16 14.1334L23.4667 6.66669L25.3334 8.53335L17.8667 16L25.3334 23.4667Z",
    fill: "currentColor"
  })));
};
export default SvgCross;